var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"\n    M21 12\n    C21 16.9706 16.9706 21 12 21\n    C7.02944 21 3 16.9706 3 12\n    C3 7.02944 7.02944 3 12 3\n  ","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Loader.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Loader;

Loader.default = Loader;
